const state = {
  user: null,
}

const getters = {

}

const mutations = {
  // eslint-disable-next-line no-shadow
  SET_AUTH_USER(state, payload) {
    state.user = payload
    sessionStorage.setItem('userData', JSON.stringify(payload))
  },
}

const actions = {
  me: async ({ commit }) => {
    try {
      const data = await window.http.get('auth/me')
      if (data.error) {
        return null
      }
      commit('SET_AUTH_USER', data)
      return data
    } catch (error) {
      return error
    }
  },
  setUser: async ({ commit }, user) => {
    commit('SET_AUTH_USER', user)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
